import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import translations from '../../services/translations/translations';
import { RootState } from '../../store/store';
import '../../style/layout/form/SidebarLink.css';

const Logout = (): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);

  const user = useSelector((state: RootState) => state.users.current);

  // AuthWrapper clears the sign-in and shows the signed-out page.
  const logout = () => {
    window.location.assign('/signed-out');
  };

  if (user === null) {
    return null;
  }

  return (
    <div
      className="sidebar-link"
      onClick={() => {
        logout();
      }}
      aria-hidden
    >
      <p className="sidebar-link-text">{t('Logout')}</p>
    </div>
  );
};

export default Logout;
